module.exports = __webpack_public_path__ + "images/emoji/smiley_cat.0b0b905536e9fa42c2df.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/smiley_cat.png
// module id = qDWs
// module chunks = 13